import CalendarColumn from "./CalendarColumn";
import { minutesToOffset } from "./calendarLayout";
import ColumnHeaders from "./ColumnHeaders";
import {
  GUTTER_WIDTH,
  HEADER_HEIGHT,
  HOUR_HEIGHT,
  MAX_COLUMN_WIDTH,
  MIN_COLUMN_WIDTH,
} from "./constants";
import classes from "./SessionsCalendar.module.css";
import TimeGutter from "./TimeGutter";

/**
 * The scrollable grid: hour gutter, one column per location, and the fillers
 * that let capped columns sit in a full-width frame. `nowMinutes` is null on
 * any day that isn't today.
 */
export default function CalendarGrid({
  columns,
  day,
  startHour,
  endHour,
  nowMinutes,
  sessionProps,
}) {
  const bodyHeight = minutesToOffset((endHour - startHour) * 60);
  const nowTop =
    nowMinutes === null ? null : minutesToOffset(nowMinutes - startHour * 60);

  return (
    <div className={classes.container}>
      <div
        className={classes.grid}
        style={{
          "--hour-height": `${HOUR_HEIGHT}px`,
          "--header-height": `${HEADER_HEIGHT}px`,
          // The trailing track soaks up the width the capped columns
          // leave over, so the calendar itself still spans full width
          gridTemplateColumns: `${GUTTER_WIDTH}px repeat(${columns.length}, minmax(${MIN_COLUMN_WIDTH}px, ${MAX_COLUMN_WIDTH}px)) 1fr`,
        }}
      >
        <div className={classes.cornerCell} />
        <ColumnHeaders columns={columns} />
        <div className={classes.headerFiller} />

        <TimeGutter
          startHour={startHour}
          endHour={endHour}
          height={bodyHeight}
          nowMinutes={nowMinutes}
          nowTop={nowTop}
        />
        {columns.map((column, index) => (
          <CalendarColumn
            key={column.key}
            column={column}
            day={day}
            startHour={startHour}
            height={bodyHeight}
            nowTop={nowTop}
            withNowDot={index === 0}
            sessionProps={sessionProps}
          />
        ))}
        <div className={classes.bodyFiller} style={{ height: bodyHeight }} />
      </div>
    </div>
  );
}
